import angular from 'angular'
import './version.service'

angular
  .module('admin.versions', ['admin.versions.service'])
  .controller('VersionsAdminCtrl', VersionsAdminCtrl)

/** @ngInject */
function VersionsAdminCtrl($scope, $stateParams, VersionsService, API) {
  var vm = this
  vm.items = []

  vm.sortType = 'name'
  vm.sortReverse = false

  function load() {
    VersionsService.list().then(function(result) {
      result.results.name = 'API'
      vm.items.push(result.results)
      vm.items.push({
        name: 'QP2',
        'api-release': API.QP2_VERSION,
        'branch-name': API.QP2_ENV,
        'build-date': new Date(),
        'build-number': API.QP2_BUILD.split('.')[0],
      })
    })
  }

  load()
}
